import React from "react";
import { useTranslation } from "react-i18next";

const AboutUsPageComponent = ({account,  logged_in, user}) => {
    const { t } = useTranslation();

    return(
        <>
            <section className='about-hero' id='about'>
                <div className='about-hero-banner' style={{marginTop:'6rem'}}>
                    <h2 style={{ lineHeight:1, fontSize:'4rem', color:'var(--clr-primary-7)'}}>{t("about.header")}</h2>
                
                        <p>{t("about.description")}</p>
                        
                </div>
            </section>

                <div className="about-us">

                    <section className="vision-mission-section">
                        <div className="vision-mission-image">
                        <img  src="./images/mission.jpeg" className="about-main-photo" alt="Vision & Mission" />
                        </div>
                        <div className="vision-mission-content">
                            <h2>{t("about.title")}</h2>
                                <ul>
                                <li>
                                    <span className="vision-mission-title">{t("about.vision_title")}</span> 
                                    {t("about.vision_description")}
                                </li>
                                <li>
                                    <span className="vision-mission-title">{t("about.mission_title")}</span> 
                                    {t("about.mission_description")}
                                </li>
                                </ul>
                        
                        </div>
                    </section>

        

                    <section className="about-page">
                        <div className="objectives-section">
                            <div className="objectives-container">
                            <div className="objectives-content">
                                <h2>{t("about.objectives")}</h2>
                                <ul>
                                <li>
                                    <span className="objective-title">{t("about.objective-title-one")}</span> 
                                    {t("about.objective-desc-one")}
                                </li>
                                <li>
                                    <span className="objective-title">{t("about.objective-title-two")}</span> 
                                    {t("about.objective-desc-two")}
                                </li>
                                <li>
                                    <span className="objective-title">{t("about.objective-title-three")}</span> 
                                    {t("about.objective-desc-three")}
                                </li>
                                <li>
                                    <span className="objective-title">{t("about.objective-title-four")}</span> 
                                    {t("about.objective-desc-four")}
                                </li>
                                </ul>
                            </div>
                            <div className="objectives-image">
                            <img  src="./images/schedule_two.jpeg" className="about-main-photo" alt="Our Objectives" />
                            </div>
                            </div>
                        </div>

                        <div className="disciplines-section">
                        <div className="disciplines-container">
                        <div className="disciplines-image">
                            {/* <img src="your-image-url" alt="Disciplines" /> */}
                            <img  src="./images/therapy_2.jpeg" className="about-main-photo" alt="Our Disciplines" />
                        </div>
                        <div className="disciplines-content">
                            <h2>{t("about.disciplines")}</h2>
                                <p>
                                    {t("about.disciplines_sub")}
                                </p>
                                <ul>
                                <li>
                                    <span className="discipline-title">{t("about.discipline-title-one")}</span> 
                                    {t("about.discipline-title-one-desc")}
                                </li>
                                <li>
                                    <span className="discipline-title">{t("about.discipline-title-two")}</span> 
                                    {t("about.discipline-title-two-desc")}
                                </li>
                                <li>
                                    <span className="discipline-title">{t("about.discipline-title-three")}</span> 
                                    {t("about.discipline-title-three-desc")}
                                </li>
                                </ul>
                        </div>
                        </div>
                        </div>

                    <div className="why-choose-us-section">
                        <div className="why-choose-us-container">
                        <div className="why-choose-us-content">
                            <h2>{t("about.why-choose-us")}</h2>
                                <ul>
                                <li>
                                    <span className="why-title">{t("about.choose-us-title-one")}</span> 
                                    {t("about.choose-us-title-one-desc")}
                                </li>
                                <li>
                                    <span className="why-title">{t("about.choose-us-title-two")}</span> 
                                    {t("about.choose-us-title-two-desc")}
                                </li>
                                <li>
                                    <span className="why-title">{t("about.choose-us-title-three")}</span> 
                                    {t("about.choose-us-title-three-desc")}
                                </li>
                                <li>
                                    <span className="why-title">{t("about.choose-us-title-four")}</span> 
                                    {t("about.choose-us-title-four-desc")}
                                </li>
                                </ul>
                        </div>
                        <div className="why-choose-us-image">
                        <img  src="./images/choose.jpeg" className="about-main-photo" alt="Why Choose Us" />
                        </div>
                        </div>
                    </div>
                    </section>
                </div>

                <section className="section contact" id="contact">
                    <div className="section-title" >
                    <h3>{t("about.wellness-journey")}</h3>
                    <div className="underline" style={{background:'var(--clr-primary-3)'}}></div>
                </div>
                <div className="section-center page-info">
                    <p style={{color:'white'}}>
                    {t("about.wellness-journey-title")}
                    </p>
                </div>
                </section>

        </>
    )
    
}
export default AboutUsPageComponent;
